import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PGWPaymentAggregatorQueryCriteriaClass extends BaseCriteriaModel {

  ccy_code?: Optional<string> = Optional.empty();
  country_code?: Optional<string> = Optional.empty();
  company_name?: Optional<string> = Optional.empty();

}

export class PGWPaymentAggregatorCriteriaModelQuery {
  query = '';

  constructor(paymentAggregatorCriteriaModel: PGWPaymentAggregatorQueryCriteriaClass) {
    console.log('Aggregator Criteria Model', paymentAggregatorCriteriaModel);

    if (!paymentAggregatorCriteriaModel) {
      return;
    }


    this.query += paymentAggregatorCriteriaModel.ccy_code.filter(x => x !== '').map(x => '&ccy_code=' + x).orElse('');
    this.query += paymentAggregatorCriteriaModel.country_code.filter(x => x !== '').map(x => '&country_code=' + x).orElse('');
    this.query += paymentAggregatorCriteriaModel.company_name.filter(x => x !== '').map(x => '&company_name=' + x).orElse('');


    this.query += '&status=' + paymentAggregatorCriteriaModel.status;
    this.query += '&orderBy=' + paymentAggregatorCriteriaModel.orderBy;
    this.query += '&order=' + paymentAggregatorCriteriaModel.order;
    this.query += '&offset=' + paymentAggregatorCriteriaModel.offset + '&limit=' + paymentAggregatorCriteriaModel.limit;
  }

}
